module.exports = __webpack_public_path__ + "img/icon-sound-off.89f1cb61.svg";